import {
  Box,
  IconButton,
  SystemIcon,
  Typography,
} from '@wishket/design-system';
import dayjs from 'dayjs';
import { twJoin } from 'tailwind-merge';

interface GrassHeaderProps {
  grassCount: number;
  onInfoClick: () => void;
}

const dateFormatString = 'YYYY년 기준';
const GrassHeader = ({ grassCount, onInfoClick }: GrassHeaderProps) => {
  return (
    <Box className="flex items-center justify-between gap-1">
      <Typography
        variant="body1"
        className={twJoin(
          'font-bold text-w-gray-900',
          'desktop:typo-subTitle2'
        )}
      >
        {grassCount}개의 성장 잔디
      </Typography>
      <Box className="flex gap-0.5">
        <Typography variant="body2" className="text-w-gray-600">
          {dayjs().format(dateFormatString)}
        </Typography>
        <IconButton size="sm" outline={false} onClick={onInfoClick}>
          <SystemIcon className="text-w-gray-600" name="medium_information" />
        </IconButton>
      </Box>
    </Box>
  );
};

export default GrassHeader;
